import { render, staticRenderFns } from "./Ubicacion.vue?vue&type=template&id=21f3cfee&scoped=true&"
var script = {}
import style0 from "./Ubicacion.vue?vue&type=style&index=0&id=21f3cfee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3cfee",
  null
  
)

export default component.exports